import { render, staticRenderFns } from "./TagsManager.vue?vue&type=template&id=6f04c123&scoped=true"
import script from "./TagsManager.vue?vue&type=script&lang=js"
export * from "./TagsManager.vue?vue&type=script&lang=js"
import style0 from "./TagsManager.vue?vue&type=style&index=0&id=6f04c123&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f04c123",
  null
  
)

export default component.exports